import React from 'react';
import { useArtistProfileImage } from '../../hooks/useArtistProfileImage';
import './ArtistAvatar.css';

interface ArtistAvatarProps {
  artistId?: number;
  artistName?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const ArtistAvatar: React.FC<ArtistAvatarProps> = ({ 
  artistId, 
  artistName = 'Unknown Artist',
  size = 'medium',
  className = '' 
}) => {
  const { profileImageUrl, isLoading, error } = useArtistProfileImage(artistId);

  const avatarClass = `artist-avatar size-${size} ${isLoading ? 'loading' : ''} ${className}`.trim();

  // Don't show loading state if there's no artistId
  if (!artistId) {
    return (
      <div className={avatarClass}>
        <span>👤</span>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={avatarClass}>
        <span>⏳</span>
      </div>
    );
  }

  // If there's an error or no image URL, show default icon
  if (error || !profileImageUrl) {
    return (
      <div className={avatarClass}>
        <span>👤</span>
      </div>
    );
  }

  return (
    <div className={avatarClass}>
      <img 
        src={profileImageUrl} 
        alt={artistName}
        onError={(e) => {
          // If image fails to load, hide it and show default icon
          e.currentTarget.style.display = 'none';
          const parent = e.currentTarget.parentElement;
          if (parent) {
            parent.innerHTML = '<span>👤</span>';
          }
        }}
      />
    </div>
  );
};